import type { PayloadAction } from '@reduxjs/toolkit';

import type { TStatusesV2Response } from 'shared/types/TRankingService';

import type { IOffersState } from 'entities/offers';

import { filterOffersByPreApprovingStatus } from './filterOffersByPreApprovingStatus';
import { getFailedPreApprovalOffers } from './getFailedPreApprovalOffers';
import { getPreApprovalResultMap } from './getPreApprovalResultMap';
import { updatePreApprovingOffer } from './updatePreApprovingOffer';

export const setPreApprovingOffersData = (state: IOffersState, { payload }: PayloadAction<TStatusesV2Response>) => {
  const { preApprovalResult } = payload || {};
  const { items = [], status = 'searching' } = preApprovalResult || {};

  const preApprovalResultMap = getPreApprovalResultMap(items);
  const failedPreApprovalOffers = getFailedPreApprovalOffers(items, status);

  state.offers = state.offers
    .filter((offer) => !failedPreApprovalOffers.includes(offer.id))
    .map((offer) => updatePreApprovingOffer(offer, preApprovalResultMap));

  state.offers = filterOffersByPreApprovingStatus(state.offers, status);
};
